export const getPaymentTransactionErrorMessage = (i18n, paymentStore, preparedTransactionId) => {
  const data = paymentStore.getPreparedTransactionErrorById(preparedTransactionId);
  const key = `unapprovedPayments.paymentConfirmation.error.${data.code}`;
  const message = i18n.getMessage(key);
  if (message !== key) {
    return i18n.getMessage(key);
  } else {
    return data.message;
  }
};
